export const common = {
  state: {
    settingMaster: [],
    memberInfo: {},
    firstClickDatePickerKey: null,
    pinnedMenu: false
  },
  mutations: {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    setSettingMaster(state, value) {
      state.settingMaster = value
    },
    setMemberInfo(state, data) {
      state.memberInfo = data
    },
    setFirstClickDatePickerKey(state, data) {
      state.firstClickDatePickerKey = data
    },
    setPinnedMenu(state, data) {
      state.pinnedMenu = data
    }
  },
  getters: {
    getMemberInfo: state => state.memberInfo,
    getFirstClickDatePickerKey: state => state.firstClickDatePickerKey,
    getPinnedMenu: state => state.pinnedMenu
  }
}
